import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

    constructor(private router: Router,
        private localStorage: LocalStorageService) { }

    ngOnInit() {
        const roles: string[] = this.localStorage.get('user-roles');
        const identity = this.localStorage.get('user-identity');

        if (roles == null || identity == null) {
            this.router.navigate(['/signin']);
        }
    }

}
